import { Card, Grid, Box, Button, Stack, Link, TableContainer, Typography } from "@mui/material";
import TablePagination from "@mui/material/TablePagination";
import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableHeader from "../shared/TableHeader";
import { PaymentRequestSearchDTO, PaymentRequestSearchField } from "@inosio/payments-sdk";
import React, { ChangeEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getActivateAllModels, getCloseAllModals, getPaymentRequestData, getPaymentRequestDetail, getResetPrState, selectPaymentRequestsState } from "./sagas/paymentrequestslice";
import moment from "moment";
import { DateRange } from "@mui/lab/DateRangePicker";
import NumberFormat from "react-number-format";
import { convertCentsToDollars } from "../../shared/util/converters";
import ResendRequestIcon from '../../icons/ResendRequestIcon.svg'
import ResendModal from "./components/ResendModal";
import PaymentRequestDetailModal from "./components/PaymentRequestDetailModal";
import SpinnerWithNoConfirmation from "../../shared/Modal/spinnerWithNoConfirmation";
import BadRequestIcon from "../../icons/Badrequesterror.svg";
import Error500 from "../../icons/505Error.svg";
import { getAvailableBankAccount } from "../billingConfiguration/sagas/billingSlice";
import { resetQuickPayState } from "../../resui/quickpayments/sagas/quickpaymentsSlice";
import NewPaymentRequestModal from "./components/NewPaymentRequestModal";

interface RequestDetails {
    lastSentDate: string;
    requestId: string;
    email: string;
}
export default function PaymentRequests() {
    //state for resend modal
    const reqDetails: RequestDetails = {
        lastSentDate: '',
        requestId: '',
        email: ''
    }

    // state for details modal
    const detailModalProps = {
        CompanyName: '',
        PropertyName: '',
        LastSentDate: '',
        PaymentRequestId: '',
        PayerName: '',
        Status: '',
        TotalAmount: 0,
    }
    const [searchField, setSearchField] = React.useState("");
    const [searchValue, setSearchValue] = React.useState("");
    const [searchChipOpen, setSearchChipOpen] = React.useState(false);
    const [searchBluePillValue, setSearchPillValue] = React.useState("");
    const searchValueInputRef = React.createRef<HTMLInputElement>();
    const columnsSelectRef = React.createRef<HTMLSelectElement>();
    const [isSearchValueEmpty, setIsSearchValueEmpty] = React.useState(false);
    const [columnFilterSearchField, setColumnFilterSearchField] = React.useState("");
    const [openNewPrModal, setOpenNewPrModal] = React.useState(false);
    const { closeAllModals, PaymentRequest, PaymentRequestDataPages, isSuccessPaymentRequestStatusDetails, isFetchingPaymentRequest, paymentRequestsError, isPaymentRequestSuccess } = useSelector(selectPaymentRequestsState);
    const [recordStartIndex, setRecordStartIndex] = React.useState(0);
    const [rangeSize, setRangeSize] = React.useState(100);
    const [currentPage, setCurrentPage] = React.useState(0);
    const [openCalendarModal, setOpenCalendarModal] = React.useState(false);
    const [dateRangeChipOpen, setDateRangeChipOpen] = React.useState(false);
    const [openResendModal, setOpenResendModal] = React.useState(false);
    const [requestDetailsState, setRequestDetailsState] = React.useState(reqDetails);
    const [detailModalState, setDetailModalState] = React.useState(detailModalProps);
    const [openDetailsModal, setOpenDetailsModal] = React.useState(false)

    const defaultStartDate = new Date();
    const defaultEndDate = new Date();
    defaultStartDate.setFullYear(defaultStartDate.getFullYear() - 1);
    defaultEndDate.setFullYear(defaultEndDate.getFullYear() + 1);

    const [calendarWidgetDateRange, setcalendarWidgetDateRange] = React.useState<DateRange<Date>>([
        // Date range to hold what the calendar currently shows
        defaultStartDate,
        defaultEndDate,
    ]);

    const [apiDateRange, setapiDateRange] = React.useState<DateRange<Date>>([
        // Date range to send to the API
        defaultStartDate,
        defaultEndDate,
    ]);

    const setSearchPageIndex = (pageNumber: number) => {
        if (!PaymentRequestDataPages[pageNumber]) {
            const newIndex = pageNumber * rangeSize;
            setRecordStartIndex(newIndex);
        }
    };

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPageNumber: number) => {
        setSearchPageIndex(newPageNumber);
        setCurrentPage(newPageNumber);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setCurrentPage(0);
        setRecordStartIndex(0);
        setRangeSize(parseInt(event.target.value));
    };

    const useStyles = makeStyles({
        gridContainer: {
            background: "#FFFFFF",
            borderRadius: "24px",

        },
    });

    const optionValues = [
        { key: PaymentRequestSearchField.Id, value: "Payment Request ID" },
        { key: PaymentRequestSearchField.Type, value: "Type" },
        { key: PaymentRequestSearchField.Amount, value: "Amount" },
        { key: PaymentRequestSearchField.Status, value: "Status" }
    ];

    const classes = useStyles();
    const dispatch = useDispatch();

    //searchbar
    const searchValueChangeHandler = (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => setSearchValue(e.target.value);
    const searchFieldChangeHandler = (e: any) => setSearchField(e.target.value);
    const searchPaymentRequests = (event: any) => {
        setSearchChipOpen(true);
        event.preventDefault();
        if (searchValueInputRef.current && searchValueInputRef?.current?.value.length !== 0) {
            setSearchPillValue(searchValueInputRef?.current?.value);
        }
    };
    const handleChooseColumnSearchField = (event: any) => {
        event.preventDefault();
        if (columnsSelectRef.current) {
            setColumnFilterSearchField(columnsSelectRef?.current?.value);
        }
    };
    const resetTableRows = () => {
        setSearchChipOpen(false);
        setSearchValue("");
        setSearchField("");
        setSearchPillValue("");
    };

    const formatSearchAmount = () => {
        const formattedAmount = parseFloat(searchValue.replace(/,/g, "")) * 100;
        if (searchValue === null || searchValue === "" || isNaN(formattedAmount)) {
            return 0;
        }
        return formattedAmount;
    };

    //calendar
    const handleCalendarSubmit = () => {
        setCurrentPage(0);
        setRecordStartIndex(0);
        setOpenCalendarModal(false);
        setapiDateRange(calendarWidgetDateRange);
        setDateRangeChipOpen(true);
    };
    const handleClickOpen = () => setOpenCalendarModal(true);
    const handleClose = () => setOpenCalendarModal(false);

    const handleClosePrModal = () => {
        //This needs to be the end all be all close for all PR modals. Each sequential modal should just invoke this guy.
        setOpenNewPrModal(false)
        dispatch({
            type: getResetPrState.type
        })
        dispatch({
            type: resetQuickPayState.type,
          });
          dispatch({
            type: getCloseAllModals.type,
          });
    }

    const handleSearchCases = () => {
        // Search field not set and date range pill not open OR search field not set and date range pill open
        if (searchField.length === 0 && dateRangeChipOpen) {
            dispatch(
                {
                    type: getPaymentRequestData.type,
                    payload: {
                        EndDate: apiDateRange[1]?.toISOString() || new Date().toISOString(),
                        StartDate: apiDateRange[0]?.toISOString() || new Date().toISOString(),
                        RangeSize: rangeSize,
                        StartIndex: recordStartIndex,
                    } as PaymentRequestSearchDTO
                }
            );
            // search field and value set and date range pill not open
        } else if (searchValue.length !== 0 && searchField.length !== 0 && !dateRangeChipOpen) {
            setCurrentPage(0);
            setRecordStartIndex(0);
            dispatch({
                type: getPaymentRequestData.type,
                payload: {
                    RangeSize: rangeSize,
                    StartIndex: recordStartIndex,
                    SearchField: searchField,
                    SearchValue: searchField === "Amount" ? formatSearchAmount() : searchValue,
                } as PaymentRequestSearchDTO
            }
            );
            // Date range pill, search field and search value all set.
        } else if (searchField.length === 0 && !dateRangeChipOpen) {
            dispatch({
                type: getPaymentRequestData.type,
                payload: {
                    EndDate: defaultEndDate.toISOString(),
                    StartDate: defaultStartDate.toISOString(),
                    RangeSize: rangeSize,
                    StartIndex: recordStartIndex,
                } as PaymentRequestSearchDTO
            });
        } else {
            setCurrentPage(0);
            dispatch({
                type: getPaymentRequestData.type,
                payload: {
                    EndDate: apiDateRange[1]?.toISOString() || new Date().toISOString(),
                    StartDate: apiDateRange[0]?.toISOString() || new Date().toISOString(),
                    RangeSize: rangeSize,
                    StartIndex: 0,
                    SearchField: searchField,
                    SearchValue: searchField === "Amount" ? formatSearchAmount() : searchValue,
                } as PaymentRequestSearchDTO
            }
            );
        }
    };

    React.useEffect(() => {
        if (searchValue.length === 0) {
            setIsSearchValueEmpty(true);
        } else {
            setIsSearchValueEmpty(false);
        }
    }, [searchValue]);

    React.useEffect(() => {
        handleSearchCases();
    }, [dispatch, apiDateRange, recordStartIndex, rangeSize, dateRangeChipOpen, searchChipOpen, searchBluePillValue]);

    React.useEffect(() => {
        if (isSuccessPaymentRequestStatusDetails || isPaymentRequestSuccess) {
            handleSearchCases();
        }
    }, [isSuccessPaymentRequestStatusDetails, isPaymentRequestSuccess])

    return (
        <Grid item xs={12} sx={{ mt: 3.5 }}>
            <Card sx={{ p: 2, display: "flex", flexDirection: "column", height: 'calc( 100vh - 144px )', pb: '64px' }} className={classes.gridContainer} style={{ position: "relative" }}>
                <> <Box sx={{ display: "flex", p: 1, pb: 2, justifyContent: "space-between", "& .MuiTextField-root": { m: 1, width: "25ch" } }}>
                    <TableHeader
                        searchValueChangeHandler={searchValueChangeHandler}
                        calendarWidgetDateRange={apiDateRange}
                        searchValue={searchValue}
                        searchFieldChangeHandler={searchFieldChangeHandler}
                        searchField={searchField}
                        optionValues={optionValues}
                        handleSearch={searchPaymentRequests}
                        setSearchChipOpen={setSearchChipOpen}
                        searchChipOpen={searchChipOpen}
                        searchValueInputRef={searchValueInputRef}
                        columnsSelectRef={columnsSelectRef}
                        searchBluePillValue={searchBluePillValue}
                        handleChooseColumnSearchField={handleChooseColumnSearchField}
                        isSearchValueEmpty={isSearchValueEmpty}
                        columnFilterSearchField={columnFilterSearchField}
                        resetSearchFilter={setSearchField}
                        resetSearchValue={setSearchValue}
                        resetTableRows={resetTableRows}
                        dateRangeChipOpen={dateRangeChipOpen}
                        defaultEndDate={defaultEndDate}
                        defaultStartDate={defaultStartDate}
                        setDateRangeChipOpen={setDateRangeChipOpen}
                        rangeSize={rangeSize}
                        recordStartIndex={recordStartIndex}
                        handleClickOpen={handleClickOpen}
                        openCalendarModal={openCalendarModal}
                        handleCalendarSubmit={handleCalendarSubmit}
                        handleClose={handleClose}
                        setcalendarWidgetDateRange={setcalendarWidgetDateRange}
                    />
                    <Box>
                        <Button
                            variant="contained"
                            style={{
                                width: "200px",
                                height: "46px",
                                borderRadius: "24px",
                                textTransform: "capitalize",
                                color: "white",
                                backgroundColor: "#39A2DB",
                                borderColor: "#39A2DB",
                            }}
                            onClick={() => {
                                setOpenNewPrModal(true)
                                dispatch({
                                    type: getActivateAllModels.type
                                })
                                dispatch({ type: getAvailableBankAccount.type, payload: { fundableOnly: true } });
                                // dispatch({
                                //     type: getApplicantsList.type,
                                //     payload: {
                                //         SearchField: PayerType.All,
                                //     } as PayerTypeSearchParamsDto
                                // })

                            }}
                            id="makePayRequestBtn"
                        >
                            New Payment Request
                        </Button>
                    </Box>
                </Box>
                    { 
                        String( paymentRequestsError.statusCode)[0] === '4' ?
                        <Grid container direction="row" spacing={2} alignItems="center" justifyContent='center' sx={{ height: '100vh' }} >
                          <Grid item display="flex" flexDirection="column" alignItems='center'>
                            <Grid item display="flex" justifyContent='center' pb={3} mt={3}>
                              <img src={BadRequestIcon} alt='400' />
                            </Grid>
                            <Grid item justifyContent='center'>
                              <Typography
                                sx={{
                                  fontFamily: "Work Sans",
                                  fontStyle: 'normal',
                                  fontWeight: 700,
                                  fontSize: '40px',
                                  lineHeight: '23px',
                                  color: '#2E82AF',
                                  textAlign: 'center',
                                  marginTop: '10px'
                                }}>
                                {
                                  paymentRequestsError.statusCode
                                }
                              </Typography>
                            </Grid>
                            <Grid mt={2} item justifyContent='center'>
                              <Typography
                                sx={{
                                  fontFamily: "Work Sans",
                                  fontStyle: 'normal',
                                  fontWeight: 400,
                                  fontSize: '20px',
                                  lineHeight: '23px',
                                  color: '#9E9E9E',
                                  textAlign: 'center',
                                  marginTop: '10px'
                                }}>
                                Page not found.
                              </Typography>
                            </Grid>
                            <Grid item justifyContent='center' mt={2} xs={8}>
                              <Typography
                                sx={{
                                  fontFamily: "Work Sans",
                                  fontStyle: 'normal',
                                  fontWeight: 400,
                                  fontSize: '14px',
                                  lineHeight: '23px',
                                  color: '#9E9E9E',
                                  textAlign: 'center',
                                  marginTop: '10px',
                                }}>
                                {paymentRequestsError.message.length === 0 ? '' : paymentRequestsError.message}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        : String( paymentRequestsError.statusCode)[0] === '5' ?
                        <Grid container direction="row" spacing={2} alignItems="center" justifyContent='center' sx={{ height: '100vh' }} >
                          <Grid item display="flex" flexDirection="column" alignItems='center'>
                            <Grid item display="flex" justifyContent='center' sx={{marginLeft:'5%'}} >
                              <img src={Error500} alt='500' style={{height:'35vh'}} />
                            </Grid>
                            <Grid item justifyContent='center'>
                              <Typography
                                sx={{
                                  fontFamily: "Work Sans",
                                  fontStyle: 'normal',
                                  fontWeight: 700,
                                  fontSize: '40px',
                                  lineHeight: '23px',
                                  color: '#2E82AF',
                                  textAlign: 'center',
                                  marginTop: '10px'
                                }}>
                                {
                                  paymentRequestsError.statusCode
                                }
                              </Typography>
                            </Grid>
                            <Grid mt={2} item justifyContent='center'>
                              <Typography
                                sx={{
                                  fontFamily: "Work Sans",
                                  fontStyle: 'normal',
                                  fontWeight: 400,
                                  fontSize: '20px',
                                  lineHeight: '23px',
                                  color: '#9E9E9E',
                                  textAlign: 'center',
                                  marginTop: '10px'
                                }}>
                                Page not found.
                              </Typography>
                            </Grid>
                            <Grid item justifyContent='center' mt={2} xs={8}>
                              <Typography
                                sx={{
                                  fontFamily: "Work Sans",
                                  fontStyle: 'normal',
                                  fontWeight: 400,
                                  fontSize: '14px',
                                  lineHeight: '23px',
                                  color: '#9E9E9E',
                                  textAlign: 'center',
                                  marginTop: '10px',
                                }}>
                                {paymentRequestsError.message.length === 0 ? '' : paymentRequestsError.message}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                       :
                        isFetchingPaymentRequest ? (
                            <Stack
                                justifyContent="center"
                                alignItems="center"
                                style={{
                                    height: "1100px",
                                }}
                            >
                                <SpinnerWithNoConfirmation />
                            </Stack>
                        )
                            :
                            <TableContainer style={{ flex: 1 }}>
                                <Table size="small" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell id="subTitle">Payment Request ID</TableCell>
                                            <TableCell id="subTitle">Name</TableCell>
                                            {/* <TableCell id="subTitle">Type</TableCell> */}
                                            <TableCell id="subTitle">Amount</TableCell>
                                            <TableCell id="subTitle">Due Date</TableCell>
                                            <TableCell id="subTitle">Status</TableCell>
                                            <TableCell id="subTitle">
                                                <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                                                    Resend Request
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody style={{ left: "28px" }}>
                                        {PaymentRequestDataPages?.[currentPage] &&
                                            PaymentRequestDataPages?.[currentPage].Rows?.map((eachRow) => {
                                                return (
                                                    <TableRow key={eachRow.PaymentRequestId}>
                                                        <TableCell id="content">
                                                            <Link
                                                                href="#"
                                                                underline="hover"
                                                                color="inherit"
                                                                onClick={() => {
                                                                    setOpenDetailsModal(true)
                                                                    setDetailModalState({
                                                                        ...detailModalState,
                                                                        CompanyName: eachRow?.CompanyName!,
                                                                        PropertyName: eachRow?.CompanyName!,
                                                                        PaymentRequestId: eachRow?.PaymentRequestId,
                                                                        Status: eachRow?.Status,
                                                                        LastSentDate: eachRow?.LastSentDate,
                                                                        TotalAmount: eachRow?.Amount,
                                                                        PayerName: eachRow?.PayerName
                                                                    })
                                                                    dispatch({
                                                                        type: getPaymentRequestDetail.type,
                                                                        payload: eachRow?.PaymentRequestId
                                                                    })
                                                                }}
                                                            >
                                                                {eachRow && eachRow?.PaymentRequestId}
                                                            </Link>
                                                        </TableCell>
                                                        <TableCell id="content">{eachRow?.PayerName}</TableCell>
                                                        {/* <TableCell id="content">{eachRow?.PayerType}</TableCell> */}
                                                        <TableCell id="content">
                                                            <NumberFormat
                                                                thousandsGroupStyle="thousand"
                                                                value={convertCentsToDollars(eachRow.Amount)}
                                                                prefix="$"
                                                                decimalSeparator="."
                                                                displayType="text"
                                                                type="text"
                                                                thousandSeparator={true}
                                                                allowNegative={true}
                                                                decimalScale={2}
                                                                fixedDecimalScale={true}
                                                            />
                                                        </TableCell>
                                                        <TableCell id="content">{moment(eachRow?.DueDate).format("MM/DD/YYYY")}</TableCell>
                                                        <TableCell id="content">{eachRow?.Status}</TableCell>
                                                        <TableCell id="content">
                                                            <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                                                                {eachRow?.Status === 'Pending' ?
                                                                    <img
                                                                        src={ResendRequestIcon}
                                                                        alt="resendrequest"
                                                                        style={{ cursor: "pointer" }}
                                                                        onClick={() => {
                                                                            setRequestDetailsState({
                                                                                ...requestDetailsState,
                                                                                lastSentDate: eachRow?.LastSentDate,
                                                                                requestId: eachRow?.PaymentRequestId,
                                                                                email: eachRow?.Email
                                                                            })
                                                                            setOpenResendModal(true)
                                                                        }}
                                                                    /> : <></>}
                                                            </Stack>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                    }
                    <TablePagination component="div" rowsPerPageOptions={[50, 100, 200]} count={PaymentRequest?.TotalCount} page={currentPage} onPageChange={handleChangePage} rowsPerPage={rangeSize} onRowsPerPageChange={handleChangeRowsPerPage} sx={{ position: 'absolute', bottom: 5, right: 10 }} />
                    {closeAllModals ? <></> : <NewPaymentRequestModal open={openNewPrModal} onClose={handleClosePrModal} />}
                    <ResendModal open={openResendModal} onClose={() => { setOpenResendModal(false) }} lastSentDate={requestDetailsState.lastSentDate} requestId={requestDetailsState.requestId} Email={requestDetailsState.email} />
                    <PaymentRequestDetailModal
                        {...detailModalState}
                        open={openDetailsModal}
                        onClose={() => {
                            setOpenDetailsModal(false)
                        }}
                    />
                    {/* {openSuccessModal && (
                        <SuccessModal 
                            open={openSuccessModal}
                            onClose={() => {
                                setOpenSuccessModal(false);
                                handleClosePrModal();
                                dispatch({
                                    type: getCloseAllModals.type,
                                })
                            }}
                            link={CreatePRResponseDto.link}
                        />
                    )} */}
                </>
            </Card>
        </Grid>
    );
}
